import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { appendElement7nmjunfw9r4 as appendElement } from '../text/Appendable.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
} from './Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../js/typeCheckUtils.mjs';
import {
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  copyToArray2j022khrow2yi as copyToArray,
  sort15ai02l4kxbfa as sort,
  sortWith4fnm6b3vw03s as sortWith,
  listOfvhqybd2zx248 as listOf,
} from './collectionJs.mjs';
import {
  emptySetcxexqki71qfa as emptySet,
  optimizeReadOnlySetbkgqv9johc5 as optimizeReadOnlySet,
} from './Sets.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  sort1opyk0uibi7i3 as sort_0,
  asList2ho2pewtsfvv as asList,
  sortWith23lt7r6b8svqd as sortWith_0,
} from './_ArraysJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from './Iterables.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  optimizeReadOnlyList2kolyxeo5m6k3 as optimizeReadOnlyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from './CollectionsKt.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../exceptions.mjs';
import {
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
  addAll1k27qatfgp3k5 as addAll,
  addAll21mdhg523wnoa as addAll_0,
} from './MutableCollections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { reversenv3adafjrtzo as reverse } from './_CollectionsJs.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../ranges/_Ranges.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../js/arrays.mjs';
import {
  checkWindowSizeStepcg5bise2nnst as checkWindowSizeStep,
  windowedIterator1l52d653czu3r as windowedIterator,
} from './SlidingWindow.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.append_jgojdo_k$(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.append_jgojdo_k$(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.append_jgojdo_k$(truncated);
  }
  buffer.append_jgojdo_k$(postfix);
  return buffer;
}
function count(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection()))
    return _this__u8e3s4.get_size_woubt6_k$();
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    count = count + 1 | 0;
    checkCountOverflow(count);
  }
  return count;
}
function toSet(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.get_size_woubt6_k$()) {
      case 0:
        tmp = emptySet();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.get_c1px32_k$(0);
        } else {
          tmp_0 = _this__u8e3s4.iterator_jk1svi_k$().next_20eer_k$();
        }

        tmp = setOf(tmp_0);
        break;
      default:
        tmp = toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_wmub5z_k$(mapCapacity(_this__u8e3s4.get_size_woubt6_k$())));
        break;
    }
    return tmp;
  }
  return optimizeReadOnlySet(toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$()));
}
function sorted(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.get_size_woubt6_k$() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sort_0(this_0);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sort(this_1);
  return this_1;
}
function average(_this__u8e3s4) {
  var sum = 0.0;
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    sum = sum + element;
    count = count + 1 | 0;
    checkCountOverflow(count);
  }
  return count === 0 ? NaN : sum / count;
}
function sortedWith(_this__u8e3s4, comparator) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.get_size_woubt6_k$() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sortWith_0(this_0, comparator);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sortWith(this_1, comparator);
  return this_1;
}
function minus(_this__u8e3s4, element) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s.next_20eer_k$();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.add_utx5q5_k$(element_0);
    }
  }
  return result;
}
function distinct(_this__u8e3s4) {
  return toList(toMutableSet(_this__u8e3s4));
}
function toList(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.get_size_woubt6_k$()) {
      case 0:
        tmp = emptyList();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.get_c1px32_k$(0);
        } else {
          tmp_0 = _this__u8e3s4.iterator_jk1svi_k$().next_20eer_k$();
        }

        tmp = listOf(tmp_0);
        break;
      default:
        tmp = toMutableList(_this__u8e3s4);
        break;
    }
    return tmp;
  }
  return optimizeReadOnlyList(toMutableList_0(_this__u8e3s4));
}
function first(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
  return _this__u8e3s4.get_c1px32_k$(0);
}
function minus_0(_this__u8e3s4, elements) {
  var other = convertToListIfNotCollection(elements);
  if (other.isEmpty_y1axqb_k$())
    return toList(_this__u8e3s4);
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!other.contains_aljjnj_k$(element)) {
      destination.add_utx5q5_k$(element);
    }
  }
  return destination;
}
function plus(_this__u8e3s4, elements) {
  if (isInterface(elements, Collection())) {
    var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + elements.get_size_woubt6_k$() | 0);
    result.addAll_h3ej1q_k$(_this__u8e3s4);
    result.addAll_h3ej1q_k$(elements);
    return result;
  } else {
    var result_0 = ArrayList().new_kotlin_collections_ArrayList_nk3udn_k$(_this__u8e3s4);
    addAll(result_0, elements);
    return result_0;
  }
}
function takeLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (n === 0)
    return emptyList();
  var size = _this__u8e3s4.get_size_woubt6_k$();
  if (n >= size)
    return toList(_this__u8e3s4);
  if (n === 1)
    return listOf(last(_this__u8e3s4));
  var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(n);
  if (isInterface(_this__u8e3s4, RandomAccess())) {
    var inductionVariable = size - n | 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.add_utx5q5_k$(_this__u8e3s4.get_c1px32_k$(index));
      }
       while (inductionVariable < size);
  } else {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _this__u8e3s4.listIterator_70e65o_k$(size - n | 0);
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      list.add_utx5q5_k$(item);
    }
  }
  return list;
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (n === 0)
    return emptyList();
  if (isInterface(_this__u8e3s4, Collection())) {
    if (n >= _this__u8e3s4.get_size_woubt6_k$())
      return toList(_this__u8e3s4);
    if (n === 1)
      return listOf(first_0(_this__u8e3s4));
  }
  var count = 0;
  var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(n);
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    list.add_utx5q5_k$(item);
    count = count + 1 | 0;
    if (count === n)
      break $l$loop;
  }
  return optimizeReadOnlyList(list);
}
function chunked(_this__u8e3s4, size) {
  return windowed(_this__u8e3s4, size, size, true);
}
function getOrNull(_this__u8e3s4, index) {
  return (0 <= index ? index < _this__u8e3s4.get_size_woubt6_k$() : false) ? _this__u8e3s4.get_c1px32_k$(index) : null;
}
function plus_0(_this__u8e3s4, element) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + 1 | 0);
  result.addAll_h3ej1q_k$(_this__u8e3s4);
  result.add_utx5q5_k$(element);
  return result;
}
function minOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  var min = iterator.next_20eer_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var e = iterator.next_20eer_k$();
    if (compareTo(min, e) > 0)
      min = e;
  }
  return min;
}
function plus_1(_this__u8e3s4, element) {
  if (isInterface(_this__u8e3s4, Collection()))
    return plus_0(_this__u8e3s4, element);
  var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  addAll(result, _this__u8e3s4);
  result.add_utx5q5_k$(element);
  return result;
}
function maxOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  var max = iterator.next_20eer_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var e = iterator.next_20eer_k$();
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = max;
    max = Math.max(a, e);
  }
  return max;
}
function minOrNull_0(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  var min = iterator.next_20eer_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var e = iterator.next_20eer_k$();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = min;
    min = Math.min(a, e);
  }
  return min;
}
function slice(_this__u8e3s4, indices) {
  if (indices.isEmpty_y1axqb_k$()) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  return toList(_this__u8e3s4.subList_xle3r2_k$(indices.get_start_iypx6h_k$(), indices.get_endInclusive_r07xpi_k$() + 1 | 0));
}
function last(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
  return _this__u8e3s4.get_c1px32_k$(get_lastIndex(_this__u8e3s4));
}
function plus_2(_this__u8e3s4, elements) {
  if (isInterface(_this__u8e3s4, Collection()))
    return plus(_this__u8e3s4, elements);
  var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  addAll(result, _this__u8e3s4);
  addAll(result, elements);
  return result;
}
function single(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.get_size_woubt6_k$()) {
    case 0:
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
    case 1:
      tmp = _this__u8e3s4.get_c1px32_k$(0);
      break;
    default:
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('List has more than one element.');
  }
  return tmp;
}
function firstOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.get_c1px32_k$(0);
}
function toMutableList(_this__u8e3s4) {
  return ArrayList().new_kotlin_collections_ArrayList_nk3udn_k$(_this__u8e3s4);
}
function lastOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.get_c1px32_k$(_this__u8e3s4.get_size_woubt6_k$() - 1 | 0);
}
function toMutableSet(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = LinkedHashSet().new_kotlin_collections_LinkedHashSet_vuym41_k$(_this__u8e3s4);
  } else {
    tmp = toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$());
  }
  return tmp;
}
function reversed(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4.get_size_woubt6_k$() <= 1;
  } else {
    tmp = false;
  }
  if (tmp)
    return toList(_this__u8e3s4);
  var list = toMutableList_0(_this__u8e3s4);
  reverse(list);
  return list;
}
function toLongArray(_this__u8e3s4) {
  var result = new BigInt64Array(_this__u8e3s4.get_size_woubt6_k$());
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = element;
  }
  return result;
}
function toByteArray(_this__u8e3s4) {
  var result = new Int8Array(_this__u8e3s4.get_size_woubt6_k$());
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = element;
  }
  return result;
}
function asSequence(_this__u8e3s4) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (asSequence$$inlined$Sequence$1())(_this__u8e3s4);
}
function drop(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (n === 0)
    return toList(_this__u8e3s4);
  var list;
  if (isInterface(_this__u8e3s4, Collection())) {
    var resultSize = _this__u8e3s4.get_size_woubt6_k$() - n | 0;
    if (resultSize <= 0)
      return emptyList();
    if (resultSize === 1)
      return listOf(last_0(_this__u8e3s4));
    list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(resultSize);
    if (isInterface(_this__u8e3s4, KtList())) {
      if (isInterface(_this__u8e3s4, RandomAccess())) {
        var inductionVariable = n;
        var last = _this__u8e3s4.get_size_woubt6_k$();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list.add_utx5q5_k$(_this__u8e3s4.get_c1px32_k$(index));
          }
           while (inductionVariable < last);
      } else {
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = _this__u8e3s4.listIterator_70e65o_k$(n);
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          list.add_utx5q5_k$(item);
        }
      }
      return list;
    }
  } else {
    list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  }
  var count = 0;
  var _iterator__ex2g4s_0 = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
    if (count >= n)
      list.add_utx5q5_k$(item_0);
    else {
      count = count + 1 | 0;
    }
  }
  return optimizeReadOnlyList(list);
}
function dropLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.get_size_woubt6_k$() - n | 0, 0));
}
function singleOrNull(_this__u8e3s4) {
  return _this__u8e3s4.get_size_woubt6_k$() === 1 ? _this__u8e3s4.get_c1px32_k$(0) : null;
}
function plus_3(_this__u8e3s4, elements) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + elements.length | 0);
  result.addAll_h3ej1q_k$(_this__u8e3s4);
  addAll_0(result, elements);
  return result;
}
function first_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return first(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    return iterator.next_20eer_k$();
  }
}
function toHashSet(_this__u8e3s4) {
  return toCollection(_this__u8e3s4, HashSet().new_kotlin_collections_HashSet_9nbh5e_k$(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
}
function toBooleanArray(_this__u8e3s4) {
  var result = booleanArray(_this__u8e3s4.get_size_woubt6_k$());
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = element;
  }
  return result;
}
function single_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return single(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    var single_0 = iterator.next_20eer_k$();
    if (iterator.hasNext_bitz1p_k$())
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Collection has more than one element.');
    return single_0;
  }
}
function toCollection(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    destination.add_utx5q5_k$(item);
  }
  return destination;
}
function toMutableList_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection()))
    return toMutableList(_this__u8e3s4);
  return toCollection(_this__u8e3s4, ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
}
function windowed(_this__u8e3s4, size, step, partialWindows) {
  step = step === VOID ? 1 : step;
  partialWindows = partialWindows === VOID ? false : partialWindows;
  checkWindowSizeStep(size, step);
  var tmp;
  if (isInterface(_this__u8e3s4, RandomAccess())) {
    tmp = isInterface(_this__u8e3s4, KtList());
  } else {
    tmp = false;
  }
  if (tmp) {
    var thisSize = _this__u8e3s4.get_size_woubt6_k$();
    var resultCapacity = (thisSize / step | 0) + ((thisSize % step | 0) === 0 ? 0 : 1) | 0;
    var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(resultCapacity);
    var index = 0;
    $l$loop: while (0 <= index ? index < thisSize : false) {
      var windowSize = coerceAtMost(size, thisSize - index | 0);
      if (windowSize < size && !partialWindows)
        break $l$loop;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(windowSize);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < windowSize)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = _this__u8e3s4.get_c1px32_k$(index_0 + index | 0);
          list.add_utx5q5_k$(tmp$ret$4);
        }
         while (inductionVariable < windowSize);
      result.add_utx5q5_k$(list);
      index = index + step | 0;
    }
    return result;
  }
  var result_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = windowedIterator(_this__u8e3s4.iterator_jk1svi_k$(), size, step, partialWindows, false);
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    result_0.add_utx5q5_k$(element);
  }
  return result_0;
}
function random(_this__u8e3s4, random) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
  return elementAt(_this__u8e3s4, random.nextInt_kn2qxo_k$(_this__u8e3s4.get_size_woubt6_k$()));
}
function last_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return last(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    var last_0 = iterator.next_20eer_k$();
    while (iterator.hasNext_bitz1p_k$())
      last_0 = iterator.next_20eer_k$();
    return last_0;
  }
}
function elementAt(_this__u8e3s4, index) {
  if (isInterface(_this__u8e3s4, KtList()))
    return _this__u8e3s4.get_c1px32_k$(index);
  return elementAtOrElse(_this__u8e3s4, index, (it) => {
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$("Collection doesn't contain element at index " + index + '.');
  });
}
function elementAtOrElse(_this__u8e3s4, index, defaultValue) {
  if (isInterface(_this__u8e3s4, KtList())) {
    // Inline function 'kotlin.collections.getOrElse' call
    return (0 <= index ? index < _this__u8e3s4.get_size_woubt6_k$() : false) ? _this__u8e3s4.get_c1px32_k$(index) : defaultValue(index);
  }
  if (index < 0)
    return defaultValue(index);
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  var count = 0;
  while (iterator.hasNext_bitz1p_k$()) {
    var element = iterator.next_20eer_k$();
    var _unary__edvuaz = count;
    count = _unary__edvuaz + 1 | 0;
    if (index === _unary__edvuaz)
      return element;
  }
  return defaultValue(index);
}
function shuffle(_this__u8e3s4, random) {
  var inductionVariable = get_lastIndex(_this__u8e3s4);
  if (1 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var j = random.nextInt_kn2qxo_k$(i + 1 | 0);
      _this__u8e3s4.set_82063s_k$(j, _this__u8e3s4.set_82063s_k$(i, _this__u8e3s4.get_c1px32_k$(j)));
    }
     while (1 <= inductionVariable);
}
function sum(_this__u8e3s4) {
  var sum = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    sum = sum + element | 0;
  }
  return sum;
}
function filterNotNull(_this__u8e3s4) {
  return filterNotNullTo(_this__u8e3s4, ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
}
function filterNotNullTo(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!(element == null)) {
      destination.add_utx5q5_k$(element);
    }
  }
  return destination;
}
var asSequence$$inlined$Sequence$1Class;
function asSequence$$inlined$Sequence$1() {
  if (asSequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($this_asSequence) {
        this.$this_asSequence_1 = $this_asSequence;
      }
      iterator_jk1svi_k$() {
        return this.$this_asSequence_1.iterator_jk1svi_k$();
      }
    }
    initMetadataForClass($);
    asSequence$$inlined$Sequence$1Class = $;
  }
  return asSequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  asSequence as asSequence2phdjljfh9jhx,
  average as average17ylfcmfrt5lc,
  chunked as chunked1umgsyuj0x9u1,
  count as count2ctzg572d5xrz,
  distinct as distinct10qe1scfdvu5k,
  dropLast as dropLast1vpiyky649o34,
  drop as drop3na99dw9feawf,
  filterNotNull as filterNotNull3qfgcwmxhwfxe,
  firstOrNull as firstOrNull1982767dljvdy,
  first as first58ocm7j58k3q,
  getOrNull as getOrNull1go7ef9ldk0df,
  joinToString as joinToString1cxrrlmo0chqs,
  joinTo as joinTo3lkanfaxbzac2,
  lastOrNull as lastOrNull1aq5oz189qoe1,
  last as last1vo29oleiqj36,
  maxOrNull as maxOrNull5i0eu9xqz7pb,
  minOrNull_0 as minOrNull2eu8keq9f1w4i,
  minOrNull as minOrNull1g8m0136x75mg,
  minus as minus1djrl64vbav3y,
  minus_0 as minus2znw4oicpx34e,
  plus_3 as plus1di085adi7f7m,
  plus_1 as plus6njewp7ynsci,
  plus_2 as plus39kp8wyage607,
  plus as plus310ted5e4i90h,
  plus_0 as plus20p0vtfmu0596,
  random as random234odtwlu7lq2,
  reversed as reversed22y3au42jl32b,
  shuffle as shuffle28202iiliqd4i,
  singleOrNull as singleOrNullrknfaxokm1sl,
  single as singleo93pzdgfc557,
  single_0 as single3ds7xj9roxi5z,
  slice as slice2g43wio9c6zdv,
  sortedWith as sortedWith2csnbbb21k0lg,
  sorted as sorted354mfsiv4s7x5,
  sum as sum1ib1hqt64m6qf,
  takeLast as takeLasttm5u17ojwaaq,
  take as take3onnpy6q7ctcz,
  toBooleanArray as toBooleanArray2u3qw7fjwsmuh,
  toByteArray as toByteArray3caw0hip00os,
  toHashSet as toHashSet1qrcsl3g8ugc8,
  toList as toList3jhuyej2anx2q,
  toLongArray as toLongArray23ixicpzp5r3w,
  toMutableList as toMutableList20rdgwi7d3cwi,
  toMutableList_0 as toMutableListoiy7juhbnlr7,
  toMutableSet as toMutableSetjdpdbr9jsqq8,
  toSet as toSet2orjxp16sotqu,
};
//endregion

//# sourceMappingURL=_Collections.mjs.map
